import { render, staticRenderFns } from "./portal-template.vue?vue&type=template&id=5d3cc767&"
import script from "./portal-template.vue?vue&type=script&lang=ts&"
export * from "./portal-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports